import { render } from "./PR38-03272024.vue?vue&type=template&id=8d519122"
import script from "./PR38-03272024.vue?vue&type=script&lang=js"
export * from "./PR38-03272024.vue?vue&type=script&lang=js"

import exportComponent from "/home/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__